import React, { Component } from "react";
import { connect } from "react-redux";
import { Segment, Grid } from "semantic-ui-react";
import { parseString } from "xml2js";
import _ from "lodash";
import AppMenu from "../../components/pages/AppMenu";
import api from "../../api";
import settings from "../../settings";
import { expireSession } from "../../actions/auth";
import ChargesTable from "./ChargesTable";
import PickUserForm from "../../components/forms/PickUserForm";
import StatementForm from "../../components/forms/StatementForm";
import { getErrorMessage } from "../messages/errorMessages";
import { getMySearchesBreadcrumb } from "../common/Breadcrumb";
import {getErrorNode} from "../../utils/errorUtil";

class MyCharges extends Component {
  state = {
    options: [],
    activities: [],
    pickedUser: this.props.user.userid,
    selectedMonth: new Date().getMonth(),
    loading: false,
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.setState({ loading: true });
    this.loadStatementRange(this.state.pickedUser);
  };

  loadStatementRange = (pickedUser) => {
    this.setState({ loading: true });
    api.lp
      .getStatementRange({ PickedUser: pickedUser })
      .then((resp) => {
        if (resp && resp.status === 200 && resp.data && resp.data.Message === "success") {
          const options = [];
          resp.data.Data.map(option => options.push({ key: option, value: option, text: option }));
          const selectedMonth = options[0].value;
          this.setState({ options, selectedMonth });
          this.loadStatements(selectedMonth);
        }
        // this.setState({ loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  }

  loadStatements = (selectedMonth) => {
    this.setState({ loading: true });
    const pickedUser = this.state.pickedUser;
    const params = {
      view: "statements2",
      period: selectedMonth,
      sserver: settings.appName,
      userID: this.props.user.userid,
      pickedUser,
      sessionID: localStorage.getItem("sessionID"),
    };
    api.lp
      .getActivitiesView(params)
      .then((res) => {
        parseString(res.data, { async: false }, (err, result) => {
          if(result == null) {
              const errorNode = getErrorNode();
              this.setState({ activityNode: errorNode });
              return;
          }
          const root = Object.keys(result)[0];
          if (root === "errors") {
            if (
              _.get(result, `${root}.error[0].$.errType`) === "unauthorized"
            ) {
              localStorage.errorMessage = _.get(
                result,
                `${root}.error[0].errMsg[0]`,
                ""
              );
              const errorMessage = getErrorMessage(
                localStorage.errorMessage,
                _.get(result, `${root}.error[0].errMsg[0]`, "")
              );
              this.props.expireSession(errorMessage);
            }
          } else {
            const activities = _.get(
              result,
              "statement.soap:Envelope[0].soap:Body[0].GetUserStatementv2Response[0].GetUserStatementv2Result[0].statement[0].activity",
              []
            );
            this.setState({ activities, pickedUser });
          }
          // this.setState({ loading: false });
        });
      })
      .catch(() => this.setState({ loading: false })).finally(() => this.setState({ loading: false }));
  }

  submit = (data) => {
    this.state.pickedUser = data.pickuser;
    this.loadStatementRange(data.pickuser);
    this.loadStatements(this.state.selectedMonth);
  };

  submitSelectedMonth = () => {
    this.loadStatements(this.state.selectedMonth);
  };

  periodChange = (selectedMonth) => {
    this.setState({ selectedMonth });
  }

  render() {
	const {errorNode} = this.state;
	if(errorNode !== undefined) return errorNode;
    return (
      <div className="container-fluid">
        <div className="padding-top-20" />
        <AppMenu
          uiData={this.props.uiData}
          userAccount={this.props.userAccount}
          history={this.props.history}
        />
        <div>
          <Segment loading={this.state.loading}>
            {getMySearchesBreadcrumb({
              currentPage: "My Charges",
              history: this.props.history,
            })}
            <br />
            <Grid stackable className="padding-left-20">
              <Grid.Row>
                <Grid.Column>
                  <span
                    className={"picked-user"}
                  >{`UserName: ${this.state.pickedUser}`}</span>
                </Grid.Column>
              </Grid.Row>
              {this.props.userAccount.acctPickUser === "1" && (
                <Grid.Row>
                  <Grid.Column>
                    <PickUserForm submit={this.submit} />
                  </Grid.Column>
                </Grid.Row>
              )}
              <Grid.Row>
                <Grid.Column>
                  <StatementForm options={this.state.options} selectedMonth={this.state.selectedMonth} submit={this.submitSelectedMonth} periodChange={this.periodChange} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <ChargesTable recs={this.state.activities} {...this.props} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, { expireSession })(MyCharges);



// WEBPACK FOOTER //
// ./src/components/myaccount/MyCharges.js